import { Location, Route } from "vue-router"

export type ResolveHomeArgs = {
  isAuthenticated: boolean
  homepagePath?: string | null
  signedOutHomepagePath?: string | null
}

// Resolves where a visitor should land when they hit "/".
// Members go to their configured homepage; logged-out and anonymous visitors
// go to the signed-out homepage. Falls back to "/" when no rule is configured.
export const resolveHomeTarget = ({
  isAuthenticated,
  homepagePath,
  signedOutHomepagePath
}: ResolveHomeArgs): string => {
  const target = isAuthenticated ? homepagePath : signedOutHomepagePath

  return target || "/"
}

// The destination reads both: "#auth" opens the modal, Stripe's callback and the
// passwordless link need the query beside it.
export const homeRedirectLocation = (
  target: string,
  { hash, query }: Pick<Route, "hash" | "query">
): Location => ({ path: target, hash, query })
